<template>
  <section>
    <p class="text-center pt-3"><q><em>We insure your life. Because you never know.</em></q></p>
    <div class="d-flex justify-content-center mt-2">
      <h1 class="w-95 p-2 pl-4 bg-color-grey border rounded text-white font-size-xxl">User Guide</h1>
    </div>
    <div class="divImg w-75">
      <img alt="user_guide_video" src="../assets/img/fake-youtube-video.png" class="img-fluid">
    </div>
  </section>
</template>

<script>
export default {
  name: 'Help'
}
</script>

<style scoped>
  .divImg{
    margin: 2% auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Help.vue